import React from 'react';
import { useNavigate } from 'react-router-dom';

export const MARKETING_PAGES = [
  { path: '/captura-de-leads', label: 'Captura de Leads' },
  { path: '/tarjeta-digital', label: 'Tarjeta Digital' },
  { path: '/analytics', label: 'Analytics' },
  { path: '/seguridad', label: 'Seguridad' },
  { path: '/wallet', label: 'Wallet' },
];

// Simple internal cross-link row between the 5 feature pages, for shared SEO
// link equity and an easy way for a reader on one page to find the others
// instead of going back to the homepage first.
const RelatedPagesLinks = ({ currentPath, linkClassName }) => {
  const navigate = useNavigate();
  const others = MARKETING_PAGES.filter((p) => p.path !== currentPath);
  return others.map((p) => (
    <button key={p.path} onClick={() => navigate(p.path)} className={linkClassName}>
      {p.label}
    </button>
  ));
};

export default RelatedPagesLinks;
